// src/AdminProductsPage.jsx
import React, { useState, useEffect } from "react";
import productsData from "./data/products.json";
import { useTheme } from "./contexts/ThemeContext";
import { useNavigate } from "react-router-dom";

export default function AdminProductsPage() {
  const { darkMode } = useTheme();
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("All");

  // Load products on first render
  useEffect(() => {
    setProducts(productsData);
  }, []);

  // Filters
  const filteredProducts = products.filter((p) => {
    const matchSearch =
      p.name.toLowerCase().includes(search.toLowerCase()) ||
      String(p.id) === search;

    const matchCategory =
      categoryFilter === "All" || p.category === categoryFilter;

    return matchSearch && matchCategory;
  });

  const categories = ["All", ...new Set(products.map((p) => p.category))];

  return (
    <div className={darkMode ? "dark" : ""}>
      <div className="min-h-screen bg-gradient-to-b from-pink-100 to-white dark:from-gray-900 dark:to-gray-800 text-gray-900 dark:text-gray-200 p-6">

        {/* HEADER */}
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-3xl font-extrabold text-pink-600 dark:text-pink-300">
            Products List
          </h1>

          <button
            onClick={() => navigate("/admin")}
            className="px-4 py-2 rounded-lg bg-white dark:bg-gray-800 shadow text-sm font-semibold text-pink-600 dark:text-pink-300 hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            ⟵ Back to Dashboard
          </button>
        </div>

        {/* Search + Category */}
        <div className="flex flex-col md:flex-row gap-4 mb-6">
          <input
            type="text"
            placeholder="Search by name or ID..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="p-2 border rounded w-full md:w-1/3 bg-white dark:bg-gray-800 dark:border-gray-700 dark:text-gray-100"
          />

          <select
            value={categoryFilter}
            onChange={(e) => setCategoryFilter(e.target.value)}
            className="p-2 border rounded w-full md:w-1/3 bg-white dark:bg-gray-800 dark:border-gray-700 dark:text-gray-100"
          >
            {categories.map((cat, idx) => (
              <option key={idx}>{cat}</option>
            ))}
          </select>
        </div>

        {/* Product Table */}
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow overflow-x-auto border dark:border-gray-700">
          <table className="w-full border-collapse">
            <thead className="bg-gray-200 dark:bg-gray-700 text-left">
              <tr>
                <th className="p-3 border dark:border-gray-600">Image</th>
                <th className="p-3 border dark:border-gray-600">Name</th>
                <th className="p-3 border dark:border-gray-600">Category</th>
                <th className="p-3 border dark:border-gray-600">Price</th>
                <th className="p-3 border dark:border-gray-600">Stock</th>
                <th className="p-3 border dark:border-gray-600">Weight</th>
                <th className="p-3 border dark:border-gray-600">Bestseller</th>
              </tr>
            </thead>

            <tbody>
              {filteredProducts.length === 0 ? (
                <tr>
                  <td
                    colSpan="7"
                    className="p-6 text-center text-gray-500 dark:text-gray-400"
                  >
                    No products found.
                  </td>
                </tr>
              ) : (
                filteredProducts.map((p) => (
                  <tr
                    key={p.id}
                    className="border-t hover:bg-gray-50 dark:hover:bg-gray-700 dark:border-gray-700"
                  >
                    <td className="p-2 border dark:border-gray-700">
                      {p.img ? (
                        <img
                          src={p.img}
                          alt={p.name}
                          className="w-16 h-16 object-cover rounded"
                        />
                      ) : (
                        "No Image"
                      )}
                    </td>
                    <td className="p-2 border dark:border-gray-700">{p.name}</td>
                    <td className="p-2 border dark:border-gray-700">{p.category}</td>
                    <td className="p-2 border dark:border-gray-700">₹{p.price}</td>
                    <td className="p-2 border dark:border-gray-700">{p.stock}</td>
                    <td className="p-2 border dark:border-gray-700">{p.weight} g</td>
                    <td className="p-2 border dark:border-gray-700">
                      {p.bestseller ? "⭐ Yes" : "—"}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}
